import {Capacitor} from '@capacitor/core';

/**
 * Detects if the current platform is a mobile device.
 * Checks both native app platform (iOS/Android via Capacitor)
 * and mobile operating system (via user agent).
 *
 * @returns true if running on mobile device (native or web), false otherwise
 */
export function isMobileDevice(): boolean {
  // Check if running as native app (iOS/Android)
  const isNativeApp = Capacitor.isNativePlatform();

  // Check if mobile OS via user agent
  const isMobileOS = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  return isNativeApp || isMobileOS;
}
